import React from 'react';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import { Chip } from '@mui/material'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { brandBlue } from '../StatCard/StatCard'

const CardHorasRecebimentoOrcamentos = (props) => {
  const { className } = props

  const horasRecebimentoOrcamentos = useSelector((state) => state.dashboard?.dashboard?.horasRecebimentoOrcamentos)

  if (!horasRecebimentoOrcamentos) {
    return null
  }

  return (
    <Chip
      className={className}
      icon={<AccessTimeRoundedIcon />}
      label={<><strong>{horasRecebimentoOrcamentos} horas</strong> para o recebimento de orçamentos</>}
      sx={{
        height: 'auto',
        py: 1,
        px: 0.5,
        borderRadius: '999px',
        fontSize: 14,
        color: brandBlue,
        backgroundColor: 'rgba(1, 81, 146, 0.08)',
        border: '1px solid rgba(1, 81, 146, 0.20)',
        '& .MuiChip-label': {
          whiteSpace: 'normal'
        },
        '& .MuiSvgIcon-root': {
          color: brandBlue
        }
      }}
    />
  );
}

CardHorasRecebimentoOrcamentos.propTypes = {
  className: PropTypes.string
}

export default CardHorasRecebimentoOrcamentos
